<template>
    <div id="free-terms-list">
        <div class="section-name-default">
            <i class="mi mi-arrow-back btn-back" @click="$router.back()"></i>Lista wolnych terminów
        </div>
        <div class="terms-container" v-show="$store.freeTermsList.length">
            <free-term v-for="freeTerm in $store.freeTermsList" :free-term="freeTerm" :type="TYPES.NEW"></free-term>
            <button v-show="moreAvailableTerms" type="submit" class="btn-outline-blue btn-choose" @click="loadNextFreeTerms()"
                    style="margin: auto;">Załaduj kolejne terminy</button>
        </div>
        <div class="empty-results journal-text" v-show="!$store.freeTermsList.length">
            Brak wolnych terminów...
        </div>
    </div>
</template>

<style lang="scss" scoped>
#free-terms-list {

    .terms-container {
        display: flex;
        flex-flow: column;
        align-items: center;
    }
    .empty-results {
        padding-left: 40px;
    }
}
</style>

<script>
import FreeTerm from './FreeTerm.vue'

import {
    FREE_TERM_TYPES as TYPES,
} from '../constants.js'

export default {
    name: 'FreeTermsList',
    components: {
        FreeTerm,
    },
    data() {
        return {
            TYPES: TYPES,
            moreAvailableTerms: true,
        }
    },
    methods: {
        loadNextFreeTerms() {
            let last_shown_term = this.$store.freeTermsList[this.$store.freeTermsList.length - 1];
            this.$bus.$emit('getNextFreeTerms', last_shown_term);
        }
    },
    mounted() {
        this.$bus.$on('moreAvailableTerms', value => {
            this.moreAvailableTerms = value;
        });
    },
    beforeDestroy() {
        // Reset FreeTerm component guard from the store.
        this.$bus.$emit('$store:setFreeTerm-hasSomeFreeTermBeenChosen', false);
        this.$bus.$off('moreAvailableTerms');
        this.$bus.$off('getNextFreeTerms');
    },
}
</script>



// WEBPACK FOOTER //
// FreeTermsList.vue?575249b6